import React, { Component } from "react";
import { generatePayableReport } from "../../services/reportService";

import BlockUi from "react-block-ui";
import { Message, Confirm } from "semantic-ui-react";
import auth from "../../services/authService";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import ReactToPrint from "react-to-print";
import PayablePrintReport from "./print/payable";

class PayableReport extends Component {
  state = {
    transactions: [],
    showSalaryForm: false,
    showError: false,
    total: 0,
    open: false,
    startDate: "",
    endDate: "",
    search: {
      name: "",
    },
  };

  handleChangeStartDate = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleChangeEndDate = (date) => {
    this.setState({
      endDate: date,
    });
  };

  handleChange = ({ currentTarget: input }) => {
    const search = { ...this.state.search };
    search[input.name] = input.value;
    this.setState({ search });
  };

  doSubmit = async () => {
    try {
      var event = new Date(this.state.startDate);
      event.setDate(event.getDate() + 1);
      let startDate = JSON.stringify(event);
      startDate = startDate.slice(1, 11);

      event = new Date(this.state.endDate);
      event.setDate(event.getDate() + 1);
      let endDate = JSON.stringify(event);
      endDate = endDate.slice(1, 11);

      this.setState({ blocking: true });

      const verifyData = {
        startDate: startDate,
        endDate: endDate,
        name: this.state.search.name,
      };

      const { data: res } = await generatePayableReport(verifyData);

      //this.setState({ blocking: false, transactions: res.data,total:res.total });

      // const res = await generateRoomReport(verifyData);

      if (res.proceed === "no") {
        this.setState({
          showError: true,
          //showSalaryForm: false,
          blocking: false,
        });
      } else {
        this.setState({
          showError: false,
          //showSalaryForm: true,
          blocking: false,
          transactions: res.data,
          total: res.total,
        });
      }
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  handleCancel = () => {
    this.setState({ open: false });
  };

  doReset = () => {
    const search = { ...this.state.search };
    search.name = "";
    this.setState({ startDate: "", endDate: "", search });
    this.reportInitialLoading();
  };

  async reportInitialLoading() {
    this.setState({ blocking: true });
    const { data: res } = await generatePayableReport();

    this.setState({
      blocking: false,
      transactions: res.data,
      total: res.total,
      showError: false,
    });
  }

  async componentDidMount() {
    this.reportInitialLoading();
  }

  render() {
    if (auth.getCurrentUser().role != "client") {
      return "Your are authorized to perform this action.";
    }
    const { transactions } = this.state;
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <Confirm
          open={this.state.open}
          header="Confirmation"
          content={this.state.confirmMsg}
          onCancel={this.handleCancel}
          onConfirm={this.doConfirmOrder}
          size="mini"
        />

        <h1 className="container__heading">Payable Report</h1>

        <div className="grid receiveable-filters">
          <DatePicker
            selected={this.state.startDate}
            onChange={this.handleChangeStartDate}
            placeholderText="Select Start Date"
            className="input"
          />
          <div></div>
          <DatePicker
            selected={this.state.endDate}
            onChange={this.handleChangeEndDate}
            className="input"
            placeholderText="Select End Date"
          />
          <div></div>
          <input
            onChange={this.handleChange}
            type="text"
            name="name"
            className="input"
            placeholder="Enter Name"
            value={this.state.search.name}
          />
          <button className="btn btn--primary" onClick={this.doSubmit}>
            Submit
          </button>
          <button className="btn btn--secondary" onClick={this.doReset}>
            Reset
          </button>
        </div>

        <div className="ui error form" style={{ width: "30%" }}>
          <Message
            negative
            style={{
              display: this.state.showError == true ? "block" : "none",
            }}
          >
            <Message.Header>Error</Message.Header>
            <p>Data not found for the dates specified.</p>
          </Message>
        </div>

        <div
          className="scrap-report"
          style={{
            display: this.state.showError == true ? "none" : "block",
          }}
        >
          <div className="scrap-report__print">
            <ReactToPrint
              trigger={() => <a href="#">Print this out!</a>}
              content={() => this.componentRef}
            />
          </div>

          <PayablePrintReport
            transactions={transactions}
            total={this.state.total}
            ref={(el) => (this.componentRef = el)}
          />
        </div>
      </BlockUi>
    );
  }
}

export default PayableReport;
